module.exports = __webpack_public_path__ + "img/ly_fc_ckxq_icon_empty.3e3a7826.png";